import React from "react";
import get from "lodash/get";
import { useTranslation } from "react-i18next";
import Modal from "../modal";
import applyDiscount from "../../utils/apply-discount";
import { notifyMobileApp } from "../../utils/biling-util";
import { useRillContext } from "../../rill/RillReact/share/base";

const {
  STRIPE: { PRICES },
} = require("../../constants");

function UpgradeConfirmationModal(props) {
  const { t } = useTranslation("coaching-portal");
  const { locals } = useRillContext();

  const { activeUser, momentTZ, query, activeUserToRequest } = locals;
  const planChange = get(query, "change", false);
  const coupon = get(activeUserToRequest, "stripe.coupon");

  let planKey, price;
  switch (activeUserToRequest.stripe.plan) {
    case "launch_twelveMonth":
      planKey = "planTwelveMonth";
      price = PRICES.twelveMonths;
      break;
    case "launch_threeMonth":
      planKey = "planThreeMonth";
      price = PRICES.threeMonths;
      break;
    case "launch_oneMonth":
      planKey = "planMonthly";
      price = PRICES.oneMonth;
      break;
    case "v2_premium_monthly":
      planKey = "planPremiumMonthly";
      price = PRICES.v2_premium_monthly;
      break;
    case "v2_premium_annually":
      planKey = "planPremiumAnnual";
      price = PRICES.v2_premium_annually;
      break;
    case "v2_standard_monthly":
      planKey = "planStandardMonthly";
      price = PRICES.v2_standard_monthly;
      break;
    case "v2_standard_annually":
      planKey = "planStandardAnnual";
      price = PRICES.v2_standard_annually;
      break;
    default:
      planKey = null;
  }
  const plan = planKey ? t(`planSwitch.${planKey}`) : "";
  const periodEnd = momentTZ(activeUserToRequest.stripe.period_end).format(
    "MMM. DD, YYYY"
  );
  const paymentAmount = applyDiscount(price, coupon).toFixed(2);

  return (
    <Modal width="600px">
      <div className="head">
        <h2 className="alt">{t("upgradeConfirmation.title")}</h2>
      </div>

      <div className="body">
        <div className="column" data-col="1/1">
          <p>{t("upgradeConfirmation.congratulations", { name: activeUser.name })}</p>
          <p>
            {t("upgradeConfirmation.successMessage", {
              plan,
              amount: paymentAmount,
              periodEnd,
            })}
          </p>
          <p>{t("upgradeConfirmation.renewAtEndOfCycle")}</p>
        </div>
      </div>

      <div className="foot">
        <a
          className="button"
          onClick={() => notifyMobileApp()}
          href="/dashboard/settings/subscription"
        >
          {t("common:close")}
        </a>
      </div>
    </Modal>
  );
}

export default UpgradeConfirmationModal;
